const animationFeaturedLink = () => {
	const background = document.querySelector('.featured-background > img');

	if (background) {
		gsap.from(background, {
			scrollTrigger: {
				trigger: background,
        start: 'top+=150px bottom',
				//markers: true,
			},
      duration: 1,
			scale: 1.05,
			ease: 'expoScale( 1.05, 1 )',
		});
	}
};

export default animationFeaturedLink;
